<lib-dialog
  [title]="'account-not-existed-dialog.text.title' | translate"
  [displayActionContainerAsColumnOnMobile]="true"
  (closeButtonClick)="closeDialog()"
>
  <div body>
    <h3 *ngIf="email?.length">
      {{
        'account-not-existed-dialog.text.not-found-account-with-email'
          | translate : { email }
      }}
    </h3>
    <h3 *ngIf="!email?.length && phoneNr?.length">
      {{
        'account-not-existed-dialog.text.not-found-account-with-phone-nr'
          | translate : { phoneNr }
      }}
    </h3>

    <lib-info-box>
      <span>{{ 'account-not-existed-dialog.text.hint' | translate }}</span>
    </lib-info-box>
  </div>

  <ng-container action>
    <button mat-stroked-button color="primary" (click)="closeDialog()">
      {{ 'account-not-existed-dialog.buttons.cancel' | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="navigateToRegister()">
      {{ 'account-not-existed-dialog.buttons.sign-up' | translate }}
    </button>
  </ng-container>
</lib-dialog>
